import { NodeModel, NodeType, findTreenodeById } from "../../models/node-model";
import { OrganizationalNodeModel } from "../customers/organizational-units/organizational-unit-service";
import { ServiceNodeModel } from "../services/service-structure-service";

export interface IFormItem {
	title: string;
	showInputsForServiceLevel: boolean;
	serviceId: string;
	costCenterId: string;
	dimensionValueIds: string[];
}

export class MeasureInputGroup {
	
	// Type of service structure this group belongs to
	inputStructureType: 'Service' | 'Organizational';
	
	root: NodeModel;		// Root node for group
	showInputsForServiceLevel: boolean; // Show inputs for service level	

	formItems: IFormItem[]; // Form items to render

	constructor(root: NodeModel, inputStructureType: 'Service' | 'Organizational', showInputsForServiceLevel: boolean) {
		this.root = root;
		this.inputStructureType = inputStructureType;
		this.showInputsForServiceLevel = showInputsForServiceLevel;
		this.formItems = [];
	}
}
